import { formatDurationLabel } from "@clipboard-health/date-time";
import { isDefined } from "@clipboard-health/util-ts";
import { type Theme } from "@mui/material";
import { Text, type TextProps } from "@src/appV2/redesign/system/ui-components";

interface SentHomeChargesTextProps extends Omit<TextProps, "color"> {
  sentHomeChargeHours: number;
  color?: (theme: Theme) => string | undefined;
}

export function SentHomeChargesText(props: SentHomeChargesTextProps) {
  const { sentHomeChargeHours, variant = "body2", color: propsColor, ...textProps } = props;

  const hoursText = formatDurationLabel(sentHomeChargeHours, "hour", { keepOriginalUnit: true });

  return (
    <Text
      variant={variant}
      color={(theme) => {
        if (isDefined(propsColor)) {
          return propsColor(theme);
        }

        return theme.palette.text.secondary;
      }}
      {...textProps}
    >
      {sentHomeChargeHours > 0 ? (
        <>
          If the workplace cancels the shift after you&apos;ve already arrived, you&apos;ll be paid{" "}
          <strong>{hoursText}</strong> at the scheduled rate.
        </>
      ) : (
        <>
          If the workplace cancels the shift after you&apos;ve already arrived, you&apos;ll only be
          paid for any time worked.
        </>
      )}
    </Text>
  );
}
